@if (viewModel) { @if (!viewModel.forbidden) {
<div class="apply-one-grid apply-one-style">
  @if (viewModel?.suggestedContracts?.length > 0) {
  <div class="bg-gray2 site-width pt-1 pt-md-2">
    <div class="container-fluid">
      <h2 class="h3 mb-0">{{getSuggestedContractTitle() | async}}</h2>
      <p class="lead">{{getSuggestedContractSubTitle() | async}}</p>
      <div class="row">
        @for (suggestedContract of viewModel?.suggestedContracts; track suggestedContract; let isLast = $last) {
        <div class="col-12 col-md-6">
          <contract-suggested [viewModel]="suggestedContract" [borderBottom]="isLast"></contract-suggested>
        </div>
        }
      </div>
    </div>
  </div>
  }
  <div class="site-width pt-2 pt-md-3">
    <div class="container-fluid">
      <h2 data-e2e="subtitle">{{getContractTitle() | async}}</h2>
      @for (contractItem of viewModel?.contracts; track contractItem; let isLast = $last) { @switch
      (contractItem.typeContract) { @case ('activeContract') {
      <active-contract
        [viewModel]="contractItem"
        [universe]="viewModel?.universe"
        [isVimEligible]="viewModel?.isVimEligible"
        [borderBottom]="isLast"
      >
      </active-contract>
      } @case ('protectedHouseContract') {
      <protected-house-contract [viewModel]="contractItem" [universe]="viewModel?.universe" [borderBottom]="isLast">
      </protected-house-contract>
      } @case ('terminatedContract') {
      <terminated-contract [viewModel]="contractItem" [universe]="viewModel?.universe" [borderBottom]="isLast">
      </terminated-contract>
      } @case ('multiContract') {
      <multi-contract-item [viewModel]="contractItem" [borderBottom]="isLast"></multi-contract-item>
      } } @if (!isLast) {
      <div class="separator mx--1 mx-md-0 mb-md-4"></div>
      } }
    </div>
  </div>
  <other-contracts [viewModel]="viewModel"></other-contracts>
</div>
} @else {
<div class="apply-one-grid apply-one-style">
  <div class="site-width">
    <div class="container-fluid">
      <div class="feedback align-items-center row pt-0 pt-md-1 pb-5">
        <div class="col-12 col-md-4 col-xl-3 px-0 px-md-1">
          <div>
            <div class="alert alert-info">
              <span class="alert-icon icon-info"></span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8 col-xl-9">
          <h2 class="h4 text-mw">{{"dashboard.forbidden.noInformation" | translate}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>
} } @else {
<div class="apply-one-grid apply-one-style">
  <div class="site-width">
    <div class="container-fluid">
      <div class="py-5" data-e2e="spinner">
        <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
      </div>
    </div>
  </div>
</div>
}
<ng-template #forbidden>
  <div class="apply-one-grid apply-one-style">
    <div class="site-width">
      <div class="container-fluid">
        <div class="feedback align-items-center row pt-0 pt-md-1 pb-5">
          <div class="col-12 col-md-4 col-xl-3 px-0 px-md-1">
            <div>
              <div class="alert alert-info">
                <span class="alert-icon icon-info"></span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8 col-xl-9">
            <h2 class="h4 text-mw">{{"dashboard.forbidden.noInformation" | translate}}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #spinner>
  <div class="apply-one-grid apply-one-style">
    <div class="site-width">
      <div class="container-fluid">
        <div class="py-5" data-e2e="spinner">
          <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
        </div>
      </div>
    </div>
  </div>
</ng-template>
